import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RecordVoiceOverIcon(props: IconProps) {
    return <Icon {...props} iconKey={"record_voice_over"}/>
}
